<template>
  <div style="padding-bottom: 68px;">
    <van-nav-bar
      title="创建简历"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft">
    </van-nav-bar>
    <div class="step-cont">
      <van-steps :active="active" active-color="#2F72F6">
        <van-step v-for="item in step" :key="item.index">
          <van-icon :name="item.icon"></van-icon>
          <div class="step-text">
            <p>{{item.title}}</p>
            <span>{{item.desc}}</span>
          </div>
        </van-step>
      </van-steps>
    </div>
    <div class="form">
      <van-cell-group class="form-cont">
        <van-field
          input-align="right"
          readonly
          value=""
          label="期望职位"
          @click="jobList = true"
          is-link
          placeholder="请选择期望职位"
          :rules="[{ message: '' }]">
        </van-field>

        <van-field
          input-align="right"
          readonly
          value=""
          label="期望行业"
          @click="industrySelect = true"
          is-link
          placeholder="请选择期望行业"
          :rules="[{ message: '' }]">
        </van-field>

        <van-field
          input-align="right"
          readonly
          value=""
          label="工作区域"
          @click="wantedArea = true"
          is-link
          placeholder="请选择工作区域"
          :rules="[{ message: ' ' }]">
        </van-field>

        <van-field
          input-align="right"
          readonly
          value=""
          label="期望薪资"
          @click="showPicker = true"
          is-link
          placeholder="请选择期望薪资"
          :rules="[{ message: ' ' }]">
        </van-field>

        <van-field
          input-align="right"
          readonly
          value=""
          label="工作性质"
          @click="showPicker = true"
          is-link
          placeholder="请选择工作性质"
          :rules="[{ message: ' ' }]">
        </van-field>

        <van-field
          input-align="right"
          readonly
          value=""
          label="求职状态"
          @click="showPicker = true"
          is-link
          placeholder="请选择求职状态"
          :rules="[{ message: ' ' }]">
        </van-field>
      </van-cell-group>
    </div>
    <div class="checkbox">
      <van-checkbox v-model="checked">您已阅读并同意 <router-link to="/demo/serviceTerms">《单位用户服务条款》</router-link>和 <router-link to="/demo/statement">《法律声明》</router-link></van-checkbox>
    </div>
    <div class="fixed-bottom">
      <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>提 交</van-button>
    </div>
    <!--选择职位-->
    <transition name="van-fade">
      <div class="job-pop" v-show="jobList">
        <div class="pop-header"><van-icon @click="jobList = false" name="fanhui"></van-icon>期望职位</div>
        <h2>请选择您的期望职位</h2>
        <van-search v-model="search" placeholder="请输入关键词搜索您的职位类型" />
        <ul class="jobs">
          <li v-for="(item,index) of jobs" :key="item.index" :class="{checked:arr.includes(index)}" @click="checkedJobs(index)" >{{item}}</li>
        </ul>
      </div>
    </transition>
    <!--选择职位2-->
    <transition name="van-fade">
      <div class="job-pop job-pop2" v-show="jobList2">
        <div class="pop-header"><van-icon @click="jobSelect" name="fanhui"></van-icon>期望职位</div>
        <h2>请选择您的期望职位</h2>
        <van-search v-model="search" placeholder="请输入关键词搜索您的职位类型" />
        <van-tree-select
          :items="items"
          height="100%"
          :active-id.sync="activeId"
          :main-active-index.sync="activeIndex"
        />
      </div>
    </transition>
    <!--选择期望行业-->
    <transition name="van-fade">
      <div class="job-pop" v-show="industrySelect" style="padding-bottom: 100px;">
        <div class="pop-header"><van-icon @click="industrySelect = false" name="fanhui"></van-icon>期望职位</div>
        <h2>请选择您的期望行业</h2>
        <van-search v-model="search" placeholder="请输入关键词搜索您的行业类型" />
        <van-tree-select
          :items="items"
          height="100%"
          :active-id.sync="activeId"
          :main-active-index.sync="activeIndex"
        />
        <div class="fixed-bottom">
          <div class="selected">
            <span>已选：</span>
            <ul>
              <li v-for="item in selectedList" :key="item.index">{{item}}</li>
            </ul>
          </div>
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>确定（3/3）</van-button>
        </div>
      </div>
    </transition>
  <!--期望工作区域-->
    <transition name="van-fade">
      <div class="job-pop" v-show="wantedArea" style="padding-bottom: 100px;">
        <div class="pop-header"><van-icon  @click="wantedArea = false" name="fanhui"></van-icon>期望职位</div>
        <h2>请选择您的期望的工作区域</h2>
        <van-search v-model="search" placeholder="请输入关键词搜索您的行业类型" />
        <ul class="jobs">
          <li v-for="(item,index) of jobs" :key="item.index" :class="{checked:arr.includes(index)}" @click="checkedJobs(index)" >{{item}}</li>
        </ul>
        <div class="fixed-bottom">
          <div class="selected">
            <span>已选：</span>
            <ul>
              <li v-for="item in selectedList" :key="item.index">{{item}}</li>
            </ul>
          </div>
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>确定（3/3）</van-button>
        </div>
      </div>
    </transition>

    <!--其他弹框-->
    <transition name="van-fade">
      <van-popup v-model="showPicker" position="bottom" style="width: 100%;">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'basicInfo',
  data() {
    return {
      value: '',
      active: 1,
      checked: true,
      jobList: false,
      jobList2: false,
      industrySelect: false,
      wantedArea: false,
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      showPicker: false,
      selectedList: ['电影/录音制作', '文化艺术/娱乐', '多媒体', '电影/录音制作', '文化艺术/娱乐', '多媒体'],
      jobs: ['销售/商务拓展', '人事/行政/财务/法务', '运维/测试', '视觉/互动/设计', '运营/专业分析', '产品/项目/高级管理',
        '市场/品牌/公关', '金融/保险'],
      arr: [],
      step: [
        {
          icon: 'jibenxinxi',
          title: '个人信息'
        }, {
          icon: 'wenjuan',
          title: '求职意向'
        }, {
          icon: 'fabu',
          title: '创建完成'
        }
      ],
      search: '',
      items: [
        { text: '人事', children: [{ text: '教育培训类', id: 11 }, { text: '互联网运营类', id: 12 }, { text: '其他', id: 13 }] },
        { text: '财务', children: [{ text: '教育培训类', id: 21 }, { text: '互联网运营类', id: 22 }] },
        { text: '行政', children: [{ text: '行政专员', id: 11 }, { text: '行政主管/办公室主任', id: 12 }, { text: '行政经理', id: 13 }, { text: '行政总监', id: 14 }] }
      ],
      activeId: [1, 2],
      activeIndex: 0
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    checkedJobs(i) {
      if (this.arr.includes(i)) {
        // includes()方法判断是否包含某一元素,返回true或false表示是否包含元素，对NaN一样有效
        // filter()方法用于把Array的某些元素过滤掉，filter()把传入的函数依次作用于每个元素，然后根据返回值是true还是false决定保留还是丢弃该元素：生成新的数组
        this.arr = this.arr.filter(function (ele) { return ele != i })
        // this.arr=this.arr.filter((ele)=>ele!=i);
        // filter()为假时删除
      } else {
        this.arr.push(i)
      }
      this.jobList2 = true
    },
    onSearch(val) {
      Toast(val)
    },
    onCancel() {
      Toast('取消')
    },
    jobSelect() {
      this.jobList2 = false
      this.jobList = true
    }
  }
}
</script>

<style lang="less" scoped>
  .step-cont{
    margin:10px 20px;
    /deep/.van-step__title{
      text-align: center;
      .step-text{
        margin-top: 14px;
      }
      i{
        font-size: 24px;
        margin-bottom: 10px;
        margin-top: -10px;
      }
      .van-icon-checked::before{
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        position: absolute;
      }
    }
  }
  .checkbox{
    margin:0 16px;
    padding:24px 0;
    border-top:1px solid #ebedf0;
    /deep/.van-checkbox{
      transform: scale(.9);
      margin-left: -18px;
    }
    /deep/.van-checkbox__label{
      font-size: 12px;
      color:#ADAEB2;
      transform: rotate(.8);
      span{
        color:#F44742
      }
    }
    /deep/.van-checkbox__icon {
      height: 16px;
      .van-icon{
        width: 16px;
        height: 16px;
        font-size: 10px;
        line-height: .8;
      }
    }
  }
  .user-cont{
    display: flex;
    justify-content: space-between;
    align-items: center;
    /deep/.van-cell{
      display: flex;
      flex:3;
      flex-direction: column;
      .van-field__label{
        margin-bottom: 26px;
      }
    }
    .user-img{
      position: relative;
      width: 88px;
      margin-right: 20px;
      flex:2;
      text-align: right;
      img{
        width: 88px;
        height: 88px;
      }
      i{
        position: absolute;
        right:0;
        top:0;
        color:#2F72F6;
        font-size: 22px;
      }
    }
  }
  .van-steps--horizontal{
    padding-left: 40px;
    padding-right: 40px;
    margin-top: 20px;
  }

  /deep/.van-step--horizontal:first-child .van-step__title{
    margin-left: -24px;
  }
  /deep/.van-step--horizontal:last-child .van-step__title{
    margin-right: -26px;
  }
  /deep/.van-step--finish .van-step__title{
    color:#2F72F6;
  }
  /deep/.van-step--horizontal .van-step__title{
    margin-left: 4px;
  }
  /deep/.van-cell{
    padding:24px 16px;
  }
  /deep/.van-hairline--top-bottom::after,/deep/.van-hairline-unset--top-bottom::after{
    display: none;
  }
  /deep/.van-cell__right-icon{
    transform: rotate(90deg);
    top:-4px;
  }

  .fixed-bottom{
    padding:10px 16px 20px;
    button{
      flex:1;
    }
  }
  .job-pop{
    position: fixed;
    left:0;
    bottom:0;
    right:0;
    background: #fff;
    top:0;
    z-index: 999;
    .fixed-bottom{
      z-index: 9999;
      flex-direction: column;
      button{
        width: 100%;
      }
      .selected{
        width: 100%;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        span{
          color:#B6B9BF;
          margin-right: 5px;
        }
        ul{
          display: flex;
          overflow: auto;
          &::-webkit-scrollbar{
            display: none;
          }
          li{
            background: #E4EBFB;
            border:1px solid #4469E3;
            color: #4469E3;
            padding:2px 24px 2px 10px;
            border-radius: 50px;
            margin:0 3px;
            font-size: 12px;
            position: relative;
            &:after{
              content: '\e926';
              position: absolute;
              font-family: van-icon;
              top:54%;
              right:8px;
              transform: translate(0,-50%);
            }
          }
        }
      }
    }
    .pop-header{
      display: flex;
      justify-content: center;
      height: 50px;
      border-bottom: 1px solid #eee;
      align-items: center;
      color:#303132;
      position: relative;
      font-size: 16px;
      background: #fff;
      i{
        position: absolute;
        left: 20px;
        top:50%;
        margin-top: -8px;
      }
    }
    h2{
      padding:22px 16px 0;
      color:#333;
      font-size: 22px;
      font-weight: bold;
      background: #fff;
    }
    .van-search{
      padding-left: 6px;
      padding-right: 6px;
      padding-bottom: 10px;
      .van-search__content{
        background: rgba(231, 236, 243, .3);
        border-radius: 50px;
        height: 40px;
        .van-cell{
          padding:0 6px;
          line-height: 40px;
          /deep/input{
            padding-left: 6px;
            padding-top: 2px;
            &::placeholder{
              color:#C9CCD2
            }
          }
          /deep/i{
            color:#E7ECF3;
          }
        }
      }
    }
    .jobs{
      display: flex;
      flex-direction: column;
      li{
        padding:20px 0;
        margin:0 20px;
        border-bottom: 1px solid #eee;
        position: relative;
        font-size: 16px;
        color:#5C5D5F;
        &.checked{
          color:#2F72F6;
        }
        &:after{
          content: '\e603';
          position: absolute;
          right:20px;
          top: 50%;
          margin-top: -7px;
          font-size: 16px;
          font-family: van-icon;
          color:#929292
        }

      }
    }
    &.job-pop2{
      background: rgba(0,0,0,.7);
      /deep/.van-tree-select{
        margin-left: 60px;
      }
    }
  }
  /deep/.van-tree-select{
    .van-sidebar-item--select::before{
      background: #2F72F6;
    }
    .van-sidebar-item--select,.van-tree-select__item--active{
      color:#2F72F6
    }
  }

</style>
